import CashierJackpot from './CashierJackpot';
export default CashierJackpot;
